import CombinationChartDataConfigComponent from "./combinationChartDataConfig.component";

angular
  .module("acl.visualizer.combinationChart.dataConfig", [
    "acl.common.localize",
    "acl.visualizer.dataModel",
    "templates-visualizer",
  ])
  .component("aclCombinationChartDataConfig", CombinationChartDataConfigComponent);
